import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { StatusItem } from "@ServerTypes/status/status.schema";

type FileStatusMap = Record<string, StatusItem>;

const filesStatusesSlice = createSlice({
  name: "filesStatuses",
  initialState: {} as FileStatusMap,
  reducers: {
    setFilesStatusesData: (_state: FileStatusMap, action: PayloadAction<StatusItem[]>) =>
      action.payload.reduce((prev: FileStatusMap, curr: StatusItem) => {
        if (curr.name.toLowerCase() == "deleted") {
          return prev;
        }
        return { ...prev, [curr.id ?? curr._id ?? ""]: curr };
      }, {}),
  },
});

const currentPathSlice = createSlice({
  name: "currentPath",
  initialState: null as string | null,
  reducers: {
    setCurrentPath: (_state: string | null, action: PayloadAction<string | null>) => action.payload,
  },
});

export const { setFilesStatusesData } = filesStatusesSlice.actions;
export const { setCurrentPath } = currentPathSlice.actions;

export const filesStatuses = filesStatusesSlice.reducer;
export const currentPath = currentPathSlice.reducer;

export default filesStatusesSlice.reducer;
